import React from "react";
import useHRCopy from "../hr/i18n/useHRCopy";

export default function KVKKModal({ onClose }) {
  const t = useHRCopy().kvkk;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="kvkk-title"
    >
      <div className="bg-white max-w-lg w-full rounded-lg shadow-lg p-6 relative">
        <h2 id="kvkk-title" className="text-xl font-bold mb-4">{t.title}</h2>
        <div className="text-sm text-gray-700 max-h-96 overflow-y-auto pr-2">
          <p>{t.p1}</p>
          <p className="mt-2">{t.p2}</p>
          <p className="mt-2">{t.p3}</p>
        </div>
        <button
          onClick={onClose}
          className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
        >
          {t.close}
        </button>
      </div>
    </div>
  );
}
